
export const Register = () => {
  return (
    <h1>Register</h1>
  )
}
